import moment from 'moment';

export const getFaultIndexes = (data) => {
  let indexFault = [];
  data?.forEach((fault, idx) => {
    if (fault === 1) {
      indexFault.push(idx + 1);
    }
  });
  return indexFault;
};

export const getFaultsList = (data, specificLocation) => {
  return Object.values(data)
    .map((location) => {
      return Object.values(location).map((machineData) => {
        const defaultData = {
          number: [],
          locationPre: 'mbta',
          location: machineData.zone_id,
          machine: machineData.deviceMac,
          address: machineData.locationAddress,
          date: '',
        };
        let faults = [];
        if (machineData.ssrFault?.includes(1)) {
          getFaultIndexes(machineData.ssrFault).forEach((faultIndex) => {
            const time = Object.values(machineData.ssrState)[faultIndex - 1]
              ?.fault_time;
            faults.push({
              ...defaultData,
              faultType: 'ssr fault',
              number: [faultIndex],
              date: time ? moment.unix(time).format('h:mma - DD/MM/YYYY') : '',
            });
          });
        }
        if (machineData.ssrOverCurrent?.includes(1)) {
          getFaultIndexes(machineData.ssrOverCurrent).forEach((faultIndex) => {
            const time = Object.values(machineData.ssrState)[faultIndex - 1]
              ?.fault_time;
            faults.push({
              ...defaultData,
              faultType: 'ssr over current',
              number: [faultIndex],
              date: time ? moment.unix(time).format('h:mma - DD/MM/YYYY') : '',
            });
          });
        }
        if (machineData.groundFault === 1) {
          faults.push({
            ...defaultData,
          });
        }
        if (
          machineData.thermocoupleFault &&
          machineData.thermocoupleFault?.includes(1)
        ) {
          getFaultIndexes(machineData.thermocoupleFault).forEach(
            (faultIndex) => {
              faults.push({
                ...defaultData,
                faultType: 'thermocouple fault',
                number: [faultIndex],
              });
            }
          );
        }
        if (machineData.bmsFault === 1) {
          faults.push({
            ...defaultData,
            faultType: 'bms fault',
          });
        }
        if (machineData.hplpFault === 1) {
          faults.push({
            ...defaultData,
            faultType: 'hp/lp fault',
          });
        }
        if (machineData.timeoutFault === 1) {
          faults.push({
            ...defaultData,
            faultType: 'timeout fault',
          });
        }
        if (machineData.thermocoupleFault === 1) {
          faults.push({
            ...defaultData,
            faultType: 'thermocouple fault',
          });
        }
        return faults;
      });
    })
    .flat(2);
};

export const electricalFaultsList = (data) => {
  return Object.values(data)
    .map((location) => {
      return Object.values(location).map((machineData) => {
        let faults = [];
        if (machineData.ssrFault?.includes(1)) {
          getFaultIndexes(machineData.ssrFault).forEach((faultIndex) => {
            const time = Object.values(machineData.ssrState)[faultIndex - 1]
              ?.fault_time;
            faults.push({
              faultType: 'ssr fault',
              number: [faultIndex],
              locationPre: 'mbta',
              location: machineData.locationId,
              machine: machineData.deviceMac,
              address: machineData.locationAddress,
              date: time ? moment.unix(time).format('h:mma - DD/MM/YYYY') : '',
            });
          });
        }
        if (machineData.ssrOverCurrent?.includes(1)) {
          getFaultIndexes(machineData.ssrOverCurrent).forEach((faultIndex) => {
            const time = Object.values(machineData.ssrState)[faultIndex - 1]
              ?.fault_time;
            faults.push({
              faultType: 'ssr over current',
              number: [faultIndex],
              locationPre: 'mbta',
              location: machineData.locationId,
              machine: machineData.deviceMac,
              address: machineData.locationAddress,
              date: time ? moment.unix(time).format('h:mma - DD/MM/YYYY') : '',
            });
          });
        }
        if (machineData.groundFault === 1) {
          faults.push({
            faultType: 'ground fault',
            number: [],
            locationPre: 'mbta',
            location: machineData.locationId,
            machine: machineData.deviceMac,
            address: machineData.locationAddress,
            date: '',
          });
        }
        if (machineData.thermocoupleFault?.includes(1)) {
          getFaultIndexes(machineData.thermocoupleFault).forEach(
            (faultIndex) => {
              faults.push({
                faultType: 'thermocouple fault',
                number: [faultIndex],
                locationPre: 'mbta',
                location: machineData.locationId,
                machine: machineData.deviceMac,
                address: machineData.locationAddress,
                date: '',
              });
            }
          );
        }
        return faults;
      });
    })
    .flat(2);
};

export const gasFaultsList = (data) => {
  return Object.values(data)
    .map((location) => {
      return Object.values(location).map((machineData) => {
        let faults = [];
        if (machineData.bmsFault === 1) {
          faults.push({
            faultType: 'bms fault',
            number: [],
            locationPre: 'mbta',
            location: machineData.locationId,
            machine: machineData.deviceMac,
            address: machineData.locationAddress,
            date: '',
          });
        }
        if (machineData.hplpFault === 1) {
          faults.push({
            faultType: 'hp/lp fault',
            number: [],
            locationPre: 'mbta',
            location: machineData.locationId,
            machine: machineData.deviceMac,
            address: machineData.locationAddress,
            date: '',
          });
        }
        if (machineData.timeoutFault === 1) {
          faults.push({
            faultType: 'timeout fault',
            number: [],
            locationPre: 'mbta',
            location: machineData.locationId,
            machine: machineData.deviceMac,
            address: machineData.locationAddress,
            date: '',
          });
        }
        if (machineData.thermocoupleFault === 1) {
          faults.push({
            faultType: 'thermocouple fault',
            number: [],
            locationPre: 'mbta',
            location: machineData.locationId,
            machine: machineData.deviceMac,
            address: machineData.locationAddress,
            date: '',
          });
        }
        return faults;
      });
    })
    .flat(2);
};

export const getWifiAlertStatusHandler = (
  switchData,
  accessKey,
  location,
  noSpecificLocation,
  accessSpecificLocation
) => {
  const gpEbpArray = [];
  let gpEbpState = null;

  if (noSpecificLocation) {
    let systemData;
   if (accessSpecificLocation) {

      systemData = location?.[1]?.[switchData] || [];
    } else {

      systemData = Object.values(location || {})?.[0]?.[switchData] || [];
    }

    gpEbpState =
      systemData?.length > 0
        ? systemData
            .map((el) =>
              Object.values(el).some(
                (gpEbp) => gpEbp.gpEbpWifiAlertStatus[accessKey] === true
              )
            )
            .some((value) => value === true)
        : null;
  } else {
    gpEbpState = Object.values(location)
      .flatMap((specificLocationEl) => {
        const systemData = Object.values(specificLocationEl)[0][switchData];

        return systemData?.length > 0
          ? systemData
              .map(
                (machine) =>
                  Object.values(machine)[0].gpEbpWifiAlertStatus[accessKey]
              )
              .some((status) => status === true)
          : null;
      })
      .some((value) => value === true);
  }

  if (gpEbpState !== null) {
    gpEbpArray.push(gpEbpState);
  }
  return gpEbpArray;
};

export const getFaultsAlertsHandler = (data) => {
  const filteredData = data.filter((switchEl) =>
    switchEl[1].machines
      ? switchEl[1].machines.length > 0
      : switchEl[1].length > 0
  );

  const faultsState = filteredData.map((el) => {
    console.log('getFaultsAlertsHandler', el);
    return el[1].some((el) => {
      if (el.machines) {
        return el.machines.some((machine) => {
          return (
            Object.values(machine)[1].gpEbpWifiAlertStatus.isFault === true
          );
        });
      } else {
        return Object.values(el)[0].gpEbpWifiAlertStatus.isFault === true;
      }
    });
  });
  console.log(faultsState, 'getFaultsAlertsHandler');
  return { faultsState, filteredData };
};
